import contractList from '../../Contract/models/index';

export default contractList;
